import type { RefObject } from "react";

export const VIEW = {
	MONTH: "month",
	YEAR: "year",
	DECADE: "decade",
};
export type CalendarViewType = (typeof VIEW)[keyof typeof VIEW];

export interface DatePickerStyledProps {
	calendarView: CalendarViewType;
	ranged?: boolean;
}

export interface DatePickerProps {
	className?: string;
	dates: Date | [Date, Date];
	minDate?: Date;
	minDateTooltipContent?: string;
	ranged?: boolean;
	ref?: RefObject<HTMLDivElement>;
	onCancel: () => void;
	onApply?: (value: Date | [Date, Date], close?: boolean) => void;
	onChange?: (value: Date | [Date, Date]) => void;
	onClickDay?: (value: Date) => boolean;
}
